<card>
  <div class="card-content">
    <div class="product-header">
      @if (isOverflowing) {
        <h3 class="product-title underline decoration-2 underline-offset-4" [tooltip]="product.name" #header>
          {{ product.name }}
        </h3>
        @if (product.editStatus === ProductStatus.INACTIVE) {
          <span class="inactive-indicator"> (Inactive)</span>
        }
      } @else {
        <h3 class="product-title underline decoration-2 underline-offset-4" #header>
          {{ product.name }}
        </h3>
        @if (product.editStatus === ProductStatus.INACTIVE) {
          <span class="inactive-indicator"> (Inactive)</span>
        }
      }
    </div>
    <div class="text-overflow-multiline body-2">{{ product.description }}</div>

    <!-- Display product tags -->
    @if (product.tags && product.tags.length > 0) {
      <div class="product-tags">
        @for (tag of product.tags; track tag.id) {
          <ud-chip
            [style]="{
              '--chip-stroke': tag.color ? 'color-mix(in srgb, ' + tag.color + ' 20%, transparent)' : 'color-mix(in srgb, #3A22DD 20%, transparent)',
              '--chip-fill': tag.color ? tag.color : '#3A22DD',
            }"
            [label]="tag.name"
          ></ud-chip>
        }
      </div>
    }
  </div>
</card>
